import getWindow from "./getWindow.js";
export default function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}


//////////////////
// WEBPACK FOOTER
// /data/websites/opacivibank.it/httpdocs/wp-content/themes/g2k-theme/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
// module id = 7
// module chunks = 0